import getBoundingClientRect from "./auth-service-tools1172.js";
import getDocumentElement from "./auth-service-tools1161.js";
import getWindowScroll from "./auth-service-tools1233.js";

function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

export { getWindowScrollBarX as default };